import { render, staticRenderFns } from "./Valttikortti.vue?vue&type=template&id=99763ed6&"
import script from "./Valttikortti.vue?vue&type=script&lang=js&"
export * from "./Valttikortti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports